import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { E as ErrorEnum, t as testChild } from './index2.js';

const safSvgCss = ".saf-svg{line-height:1}";

const SafSvg = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.semantic = undefined;
    this.animated = undefined;
    this.svgData = '';
    this.size = undefined;
    this.color = undefined;
    this.isStore = undefined;
    this.svgUse = undefined;
    this.svgUseClass = '';
  }
  /* istanbul ignore next  */
  /* Ignoring jest environment does not support the parsing of SVGs from text */
  /**
   * Function to parse a SVGSVGElement from svg markup in text
   * @param svgString - string. svg markup as a text
   * @returns - SVGSVGElement.
   */
  buildSvg(svgString) {
    // Create an SVG element from the svgString prop
    const parser = new DOMParser();
    const document = parser.parseFromString(svgString, 'text/html');
    return document.querySelector('svg');
  }
  buildSvgUse(svgUse) {
    // Create an SVG element with a USE reference and append it to the host
    return this.buildSvg(`<svg class="${this.svgUseClass}"><use xlink:href="#saf-svg-store-${svgUse}"></use></svg>`);
  }
  /**
   * Utility function to append an SVGSVGElement to another host element.
   * It deletes any other existing svg in the host element before appending svgElem.
   * @param hostElem - HTMLElement. The host element.
   * @param svgElem - SVGSVGElement. The svg to be appended.
   */
  appendSvgToHost(hostElem, svgElem) {
    var _a;
    // Determine the proper host element
    const root = (_a = hostElem.shadowRoot) !== null && _a !== void 0 ? _a : hostElem;
    // Is there an existing SVG that needs to removed?
    const svgChild = hostElem.querySelector('svg');
    if (svgChild) {
      root.removeChild(svgChild);
    }
    // Add the color and size to the SVG, if defined
    if (this.size) {
      hostElem.style.height = this.size;
      svgElem.style.height = this.size;
      svgElem.style.width = this.size;
    }
    if (this.color)
      svgElem.style.color = this.color;
    // Append the SVG element
    root.append(svgElem);
  }
  appendSvgStore() {
    // Build the SVG store and append it to the body
    const svgStoreElem = this.buildSvg(this.svgData);
    // Ensure that the SVG store has an ID attribute
    if (!svgStoreElem.id) {
      console.error(ErrorEnum.safSvgStoreId);
      return;
    }
    const body = document.querySelector('body');
    svgStoreElem.style.height = '0';
    svgStoreElem.style.width = '0';
    if (body) {
      // Don't attach the SVG store twice
      if (svgStoreElem.id && !body.querySelector(`#${svgStoreElem.id}`)) {
        body.prepend(svgStoreElem);
      }
    }
    // Build the SVG element that will USE the store and append it to the host
    this.svgElem = this.buildSvgUse(this.svgUse);
    this.appendSvgToHost(this.hostElem, this.svgElem);
  }
  appendSvgElem() {
    // Build the SVG element and append it to the host
    this.svgElem = this.buildSvg(this.svgData);
    this.appendSvgToHost(this.hostElem, this.svgElem);
  }
  buildSemantic() {
    if (this.svgElem && this.hostElem.shadowRoot) {
      this.hostElem.shadowRoot.append(this.svgElem);
    }
    if (this.size) {
      this.hostElem.style.height = this.size;
      this.hostElem.style.width = this.size;
      // Fix for safari rendering bug
      this.svgElem.style.height = this.size;
      this.svgElem.style.width = this.size;
    }
    if (this.color)
      this.hostElem.style.color = this.color;
  }
  buildShorthand() {
    if (this.isStore) {
      this.appendSvgStore();
    }
    else {
      this.appendSvgElem();
    }
  }
  componentWillLoad() {
    if (this.semantic) {
      this.svgElem = this.hostElem.querySelector('svg');
      testChild(this.svgElem, ErrorEnum.safSvg, this.buildSemantic.bind(this));
    }
  }
  componentDidRender() {
    var _a;
    if (this.animated) {
      const svgScript = this.svgElem.querySelector('script');
      if (svgScript) {
        const script = document.createElement('script');
        script.text = svgScript.textContent;
        this.svgElem.appendChild(script);
        svgScript.remove(); // Avoid duplicate script tags
      }
    }
    const root = (_a = this.hostElem.shadowRoot) !== null && _a !== void 0 ? _a : this.hostElem;
    const svgElem = root.querySelector('svg');
    svgElem === null || svgElem === void 0 ? void 0 : svgElem.setAttribute('focusable', 'false');
  }
  render() {
    return h(Host, { class: "saf-svg" }, !this.semantic && void this.buildShorthand());
  }
  get hostElem() { return this; }
  static get style() { return safSvgCss; }
}, [0, "saf-svg", {
    "semantic": [4],
    "animated": [4],
    "svgData": [1, "svg-data"],
    "size": [1],
    "color": [1],
    "isStore": [4, "is-store"],
    "svgUse": [1, "svg-use"],
    "svgUseClass": [1, "svg-use-class"]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["saf-svg"];
  components.forEach(tagName => { switch (tagName) {
    case "saf-svg":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, SafSvg);
      }
      break;
  } });
}

export { SafSvg as S, defineCustomElement as d };

